class CheckoutTimer extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('dy:checkout:nudge:init', () => {
      this.template = this.getAttribute('data-template');
      if(this.template == 'checkout') {
        sessionStorage.setItem('marlow-checkout-visited', true);
        this.style.display = 'flex';
      }
      /* if cookie with timer duration exists, use that as initial time
        if cookie doesn't exist, use time duration specified in window.Marlow.checkout_nudge object
      */
      let timerCookieValue = (document.cookie.match(/^(?:.*;)?\s*_marlow_checkout_nudge_timer\s*=\s*([^;]+)(?:.*)?$/)||[,null])[1];
      if(timerCookieValue && timerCookieValue.indexOf('undefined') == -1 )  this.time = timerCookieValue;
      else if (window.Marlow?.checkout_nudge?.timer_duration) this.time = window.Marlow.checkout_nudge.timer_duration;

      /* set cookie with leftover timer duration on page leave so user can continue timer duration on another page */
      window.addEventListener("beforeunload", function (e) {
        const d = new Date();
        d.setTime(d.getTime() + (24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        let cvalue = document.getElementById("time-left").innerHTML == '00:00' ? this.time : document.getElementById("time-left").innerHTML;
        document.cookie = `_marlow_checkout_nudge_timer=${cvalue};${expires};path=/`;     
      });

      /* fires when overlay is closed: closeOverlay() in CheckoutOverlay component */
      window.addEventListener('reset-timer', () => {
        document.getElementById("time-left").innerHTML = window.Marlow?.checkout_nudge?.timer_duration;
        this.startTimer(true);
      });

      document.getElementById("time-left").innerHTML = this.time;

      //only start timer if the user has visited the checkout page during the current session
      if(sessionStorage.getItem('marlow-checkout-visited')) this.startTimer(true);
   });
  }

  checkSecond = (sec) => {
    if (sec < 10 && sec >= 0 && sec[0] != "0") sec = "0" + sec;
    if (sec < 0) sec = "59";
    return sec;
  }

  animateTimerBar = (time, timeTotal) => {
    let currentMinutes = parseInt(time.split(':')[0][0] == '0' ? time.split(':')[0][1] : time.split(':')[0]);
    let currentSeconds = parseInt(time.split(':')[1][0] == '0' ? time.split(':')[1][1] : time.split(':')[1]) + (60 * currentMinutes);
    let totalMinutes = parseInt(timeTotal.split(':')[0][0] == '0' ? timeTotal.split(':')[0][1] : timeTotal.split(':')[0]);
    let totalSeconds = parseInt(timeTotal.split(':')[1][0] == '0' ? timeTotal.split(':')[1][1] : timeTotal.split(':')[1]) + (60 * totalMinutes);
    if(time == '59:59') currentSeconds = 0;
    this.querySelector('.js-current-time').style.width = `calc(148px - ${(currentSeconds * 148)/ totalSeconds}px)`;
    if(this.querySelector('.js-current-time').classList.contains('expired'))  setTimeout(() => {this.querySelector('.js-current-time').classList.remove('expired')}, 0)
  }

  startTimer = (initial) => {
    /* this fires once every second until timer hits 0
      - updates timer bar HTML
      - fires animateTimerBar() to animate timer bar
      - fires showCheckoutOverlay() when timer hits 0 */
      let presentTime = document.getElementById("time-left").innerHTML;
      let timeArray = presentTime.split(/[:]+/);
      let m = timeArray[0];
      let s = this.checkSecond(initial ? timeArray[1] : timeArray[1] - 1);
      let timesUp = false;
      if (s == 59) m = m - 1;
      if ((m + "").length == 1) m = "0" + m;
      if (m < 0) {
        m = "59";
        if(s == '59') timesUp = true;
      }
      document.getElementById("time-left").innerHTML = m + ":" + s;
      this.animateTimerBar(document.getElementById("time-left").innerHTML, window.Marlow?.checkout_nudge?.timer_duration);
      !timesUp ? setTimeout(this.startTimer,1000) : this.showCheckoutOverlay();
  }

  showCheckoutOverlay = () => {
    /*fire init-checkout-overlay event. Event listener is in CheckoutOverlay component */
    document.getElementById("time-left").innerHTML = "00:00";
    this.querySelector('.js-current-time').classList.add('expired');
    const initCheckoutOverlay = new CustomEvent('init-checkout-overlay');
    window.dispatchEvent(initCheckoutOverlay);
  }
  
}

customElements.define("checkout-timer", CheckoutTimer);
class CheckoutOverlay extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('dy:checkout:nudge:init', () => {
      this.template = this.getAttribute('data-template');
      this.modal = this.querySelector('.overlay-modal');
      this.settings = window.Marlow?.checkout_nudge;
      window.addEventListener('init-checkout-overlay', () => {this.initCheckoutOverlay();});
      if(this.template == 'checkout') this.querySelector('cart-checkout-button').addEventListener('click', (e) => {
        let ctaHref;
        if(e.target.classList.contains('shop-now')) ctaHref = `https://${window.Shopify.shop}`;
        else if(e.target.classList.contains('partially-oos')) location.reload();
        this.closeOverlay(ctaHref);
      });
      this.querySelector('.icon-close').addEventListener('click', () => {
        this.closeOverlay();
      });
    });
  }
  dispatchOverlayBackground(){
    const initOverlayBackground = new CustomEvent('init-overlay', {detail: this.getAttribute('data-label')});
    window.dispatchEvent(initOverlayBackground);
  }
  closeOverlay(redirect){
    if(redirect){
      window.location.href = redirect;
    } else {
      const initOverlayBackground = new CustomEvent('close-overlay', {detail: this.getAttribute('data-label')});
      const resetTimer = new CustomEvent('reset-timer');
      window.dispatchEvent(initOverlayBackground);
      if(this.template == 'checkout') window.dispatchEvent(resetTimer);
      this.style.display = 'none';
      this.style.opacity = '0';
    }
  }
  checkCart = () => {
    return fetch('/cart?view=ajax').then(cart => cart.json()).then(data => {
      /*returns 1 of 3 outcomes based off of cart conditions
        result = 1 - entire cart is unavailable 
        result = 2 - only certain products in the cart are unavailable
        result = 3 - everything in the cart is available
      */
      let result;
      if(data.some(item => !item.available)) data.length == data.filter(item => !item.available).length ? result = 1 : result = 2
      else result = 3;
      return result;
    });
  }
  updateOverlayContent = (copy) => {
    this.modal.querySelector('.h2').innerHTML = copy.title;
    this.modal.querySelector('p').innerHTML = copy.description;
    this.modal.querySelector('.button').innerHTML = copy.cta;
  }
  initCheckoutOverlay(){
    /* fires whenever timer hits 0 in CheckoutTimer component */

    this.checkCart().then(res => {
      let copy = {};

      /*since it's super hard to replicate cart conditions 1 and 2, you can also set cookies to bypass the logic:
      _marlow_checkout_nudge_1 for variation 1 (out of stock)
      _marlow_checkout_nudge_2 for variation 2 (partially out of stock)
      */

      if(res == 1 || document.cookie.indexOf('_marlow_dev_checkout_nudge_1=') != -1 ){
        copy = this.settings.copy_out_of_stock;
        this.querySelector('cart-checkout-button').classList.add('shop-now');
      } else if (res == 2 || document.cookie.indexOf('_marlow_dev_checkout_nudge_2=') != -1 ){
        this.querySelector('cart-checkout-button').classList.add('partially-oos');
        copy = this.settings.copy_partially_in_stock;
      } else copy = this.settings.copy_in_stock;
       
      return copy;
    }).then(copy => {
      this.updateOverlayContent(copy);
      this.style.display = 'block';
      setTimeout(() => {
        this.style.opacity = 1;
        this.dispatchOverlayBackground();
      }, 250);
    });
  }
}

customElements.define("checkout-overlay", CheckoutOverlay);


